import React, { FC } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { Box } from "../../../../../../components/box";
import { Icon } from "../../../../../../components/icon";
import { CreateForm } from "./create-form";
import { PATH } from "../../constant/path";

export const Create: FC = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() => {
                history.push(PATH.HOME);
              }}
            >
              <Icon.ArrowLeft />
            </div>
            TẠO PHIẾU ĐỀ NGHỊ VĂN PHÒNG PHẨM
          </div>
        </div>
        <Box title="Nội dung">
          <CreateForm />
        </Box>
      </div>
    </div>
  );
});
